import { ADD_OTP, ADD_REFERRAL, ALL_APPOINTMENT_COUNT, DELETE_OTP, DELETE_REFERRAL, DOCTOR_APPOINTMENT_COUNT, GET_OTP, GET_REFERRAL, GET_USER_DATA, LOGIN_ADMIN, LOGIN_SUCCESS, LOGOUT_SUCCESS, MASTER_DASHBOARD, SEND_OTP, UPDATE_OTP, UPDATE_REFERRAL, USER_BARCODE } from "../actions/Admin.action";

const initialState = {
    LoginAdmin: '',
    isAuthenticated: localStorage.getItem('isAuthenticated') === 'true',
    SendOtp: '',
    userBarcode: '',
    masterCount: '',
    allAppointmentCount: '',
    doctorAppointmentCount: '',
    getUserData: '',
    addOtp: '',
    getOtp: '',
    updateOtp: '',
    deleteOtp: '',
    addReferral: '',
    getReferral: '',
    updateReferral: '',
    deleteReferral: '',
}

const adminReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_ADMIN:
            return { ...state, LoginAdmin: action.payload };
        case LOGIN_SUCCESS:
            return { ...state, isAuthenticated: true };
        case LOGOUT_SUCCESS:
            return { ...state, isAuthenticated: false };
        case SEND_OTP:
            return { ...state, SendOtp: action.payload };
        case USER_BARCODE:
            return { ...state, userBarcode: action.payload };
        case MASTER_DASHBOARD:
            return { ...state, masterCount: action.payload };
        case ALL_APPOINTMENT_COUNT:
            return { ...state, allAppointmentCount: action.payload };
        case DOCTOR_APPOINTMENT_COUNT:
            return { ...state, doctorAppointmentCount: action.payload };
        case GET_USER_DATA:
            return { ...state, getUserData: action.payload };
        case ADD_OTP:
            return { ...state, addOtp: action.payload };
        case GET_OTP:
            return { ...state, getOtp: action.payload };
        case UPDATE_OTP:
            return { ...state, updateOtp: action.payload };
        case DELETE_OTP:
            return { ...state, deleteOtp: action.payload };
        case ADD_REFERRAL:
            return { ...state, addReferral: action.payload };
        case GET_REFERRAL:
            return { ...state, getReferral: action.payload };
        case UPDATE_REFERRAL:
            return { ...state, updateReferral: action.payload };
        case DELETE_REFERRAL:
            return { ...state, deleteReferral: action.payload };
        default:
            return state;
    }
}

export default adminReducer;